
import atlas from '@/components/atlas.vue';
export default {
    name: 'gallery',
    props: ['type', 'source'],
    components: { atlas },
    data() {
        return {
            loading: false,  //加载
            hot_type: 1,  //类型
            currentPage: 1, //当前页
            sourceDate: ''
        }
    },
    computed: {
        /** 作品列表是否有可渲染数据 */
        hasListData() {
            return Array.isArray(this.sourceDate?.data) && this.sourceDate.data.length > 0
        },
    },
    watch: {
        hot_type(val) {
            this.hot_type = val
            this.currentPage = 1
            this.type == 1 ? this.getUserInfo(val, this.currentPage) : this.getOtherUserInfo(val, this.currentPage)
        },
        source(val) {
            this.applySource(val)
        }
    },
    mounted() {
        this.applySource(this.source)
    },
    methods: {
        /** 同步父级传入的作品分页数据，空列表时不清空字段以免报错 */
        applySource(val) {
            this.loading = true
            this.sourceDate = val && typeof val === 'object' ? val : { data: [], total: 0 }
            if (this.sourceDate.per_page != null) {
                this.sourceDate.per_page = parseInt(this.sourceDate.per_page)
            }
            this.loading = false
        },
        // 获取本人个人信息
        async getUserInfo(type = 1, page = 1) {
            this.sourceDate = { data: [], total: 0 }
            this.loading = true
            // const res = await $global.galleryList({ page: query.page == undefined ? 1 : query.page, order_type: query.order_type == undefined ? 2 : query.order_type })
            let res = await this.$global.userInfo({ "page": page, "order_type": type, 'page_num': 20 })
            // console.log(page,type,'typetypetypetypetypetype');
            console.log(res, 'res')
            this.sourceDate = res.code === 200 ? res.data.worksList : { data: [], total: 0 }
            if (this.sourceDate.per_page != null) {
                this.sourceDate.per_page = parseInt(this.sourceDate.per_page)
            }
            this.loading = false
        },
        // 点击页码
        handleCurrentChange(val) {

            this.currentPage = val
            this.type == 1 ? this.getUserInfo(this.hot_type, this.currentPage) : this.getOtherUserInfo(this.hot_type, this.currentPage)
        },
        // 获取他人个人信息
        async getOtherUserInfo(type = 1, page = 1) {
            this.loading = true
            let res = await this.$global.otherUserWorks({ "page": page, "order_type": type, "user_id": this.$route.params.id })
            console.log(res, 'res')
            this.sourceDate = res.code === 200 ? res.data.worksList : { data: [], total: 0 }
            this.loading = false
        },
    }
}
